import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Flex,
  BoxProps,
  Portal,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { FaChevronDown } from "react-icons/fa6";
import { LSTIconMapping } from "@constants/common";

const MenuItemProps = {
  p: "6px 8px",
  borderRadius: "6px",
  fontSize: "14px",
  fontWeight: "400",
};

const SelectedMenuItemProps = {
  ...MenuItemProps,
  bg: "#F5F5F7",
  color: "#142528",
  fontWeight: "600",
  lineHeight: "20px",
  letterSpacing: "-0.70px",
};

interface StableOutputTokenSelectProps extends BoxProps {
  disabled?: boolean;
  selected: string;
  onTokenSelect?: (selected: string) => void;
  tokenBgColor?: string;
}

const StableOutputTokenSelect = ({
  selected,
  onTokenSelect,
  disabled = false,
  tokenBgColor,
  ...rest
}: StableOutputTokenSelectProps) => {
  const options = [
    {
      key: "USDC",
      title: "USDC",
      priority: 1,
    },
    {
      key: "USDT",
      title: "USDT",
      priority: 2,
    },
  ];

  const bgColor = tokenBgColor || "#ECECEC";

  return (
    <Flex w="100%" mb="2.5rem" {...rest} position={"unset"}>
      <Menu placement={"bottom-end"}>
        <MenuButton
          as={Button}
          rightIcon={
            !disabled ? <FaChevronDown fontSize={"12px"} /> : undefined
          }
          isDisabled={disabled}
          w="100%"
          h="36px"
          textAlign="left"
          className="menuButtonStake"
          p={{ base: "6px", md: "6px 8px 6px 6px" }}
          borderRadius="6px"
          bg={bgColor}
          _hover={{
            bg: { bgColor },
          }}
          _active={{
            bg: { bgColor },
          }}
          _disabled={{
            bg: { bgColor },
          }}
          fontWeight="600"
          fontSize={{ base: "14px", md: "16px" }}
          letterSpacing="-0.70px"
        >
          <Flex alignItems="center" gap="8px">
            {LSTIconMapping[selected] && (
              <BaseImage
                width={18}
                height={18}
                alt="token"
                src={LSTIconMapping[selected]}
              />
            )}
            <Flex alignItems="center" justify="space-between" flex={1} gap={2}>
              <Box flex={1}>{selected}</Box>
            </Flex>
          </Flex>
        </MenuButton>
        <Portal>
          <MenuList
            transformOrigin="top !important"
            w={{
              base: "340px",
              sm: "100%",
            }}
            p="8px"
            border="1px solid #AEDFCA"
            bg="backgroundCard"
            fontSize="14px"
            fontWeight="400"
          >
            {options.map((option, index) => {
              const props =
                option.key === selected
                  ? { ...SelectedMenuItemProps }
                  : { ...MenuItemProps };
              return (
                <MenuItem
                  {...props}
                  padding={2}
                  marginBottom={1}
                  key={index}
                  onClick={() => onTokenSelect?.(option.key)}
                >
                  <Flex
                    justifyContent="space-between"
                    w="100%"
                    alignItems="center"
                  >
                    <Flex alignItems="center" gap="8px" flex={1}>
                      {LSTIconMapping[option.key] && (
                        <BaseImage
                          width={24}
                          height={24}
                          alt="token"
                          src={LSTIconMapping[option.key]}
                        />
                      )}
                      <Flex
                        justify="space-between"
                        flex={1}
                        alignItems="center"
                        gap={2}
                      >
                        <Box flex={1} fontSize={18}>
                          {option.title}
                        </Box>
                      </Flex>
                    </Flex>
                  </Flex>
                </MenuItem>
              );
            })}
          </MenuList>
        </Portal>
      </Menu>
    </Flex>
  );
};

export default StableOutputTokenSelect;
